import { useEffect, useRef } from "react";
import { AI_SPEND_TOOLTIP, AiSpendIcon } from "./ai-spend";

export interface LessonAdvancedModePromptModalProps {
  readonly open: boolean;
  readonly lessonTitle: string;
  readonly rationale: string;
  readonly busy?: boolean;
  readonly onAcceptAdvanced: () => void;
  readonly onPreferSimple: () => void;
}

export function LessonAdvancedModePromptModal({
  open,
  lessonTitle,
  rationale,
  busy,
  onAcceptAdvanced,
  onPreferSimple,
}: LessonAdvancedModePromptModalProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const el = dialogRef.current;
    if (!el) return;
    if (open && !el.open) el.showModal();
    else if (!open && el.open) el.close();
  }, [open]);

  if (!open) return null;

  return (
    <dialog ref={dialogRef} className="teacher-modal lesson-advanced-mode-modal">
      <div className="teacher-modal-card" role="document">
        <h2 className="teacher-modal-title">Advanced mode suggested</h2>
        <p className="muted small" style={{ marginTop: 0 }}>
          {lessonTitle.trim() || "Untitled lesson"}
        </p>
        <p style={{ marginTop: "0.75rem" }}>{rationale}</p>
        <p className="muted small">
          Advanced mode gives students a full-page multi-file workspace with a file browser. Simple mode keeps
          everything in one editor with instructions beside it. Best for most lessons.
        </p>
        <div className="teacher-modal-actions">
          <button
            type="button"
            className="btn secondary"
            disabled={busy}
            title={AI_SPEND_TOOLTIP}
            onClick={() => void onPreferSimple()}
          >
            <AiSpendIcon /> {busy ? "Regenerating…" : "No thanks, use simple mode"}
          </button>
          <button type="button" className="btn primary" disabled={busy} onClick={onAcceptAdvanced}>
            Use advanced mode
          </button>
        </div>
      </div>
    </dialog>
  );
}
